import { Box, Typography } from '@mui/material'
import { Link } from '.'
import { useScrollIntoView } from 'src/hooks/useScrollIntoView'

type BenefitsProps = {
    link: Link
}

const Benefits = ({ link }: BenefitsProps) => {
    const benefits = [
        {
            imageSrc: 'https://res.cloudinary.com/dae9ughdn/image/upload/f_webp,q_auto,w_150/scs/site/efficient-processing_qx2ne7.gif',
            title: 'Efficient Processing',
            description: 'Expedient and efficient processing of all new Joinder Agreements.'
        },
        {
            imageSrc: 'https://res.cloudinary.com/dae9ughdn/image/upload/f_webp,q_auto,w_150/scs/site/expedited-requests_vudae8.gif',
            title: 'Expedited Requests',
            description: 'Expedited processing of disbursement requests (unlimited monthly disbursements).'
        },
        {
            imageSrc: 'https://res.cloudinary.com/dae9ughdn/image/upload/f_webp,q_auto,w_150/scs/site/online-access_tiapmi.gif',
            title: 'Online Account Access',
            description: 'Real time account access to monitor your deposits and request disbursements'
        },
        {
            imageSrc: 'https://res.cloudinary.com/dae9ughdn/image/upload/f_webp,q_auto,w_150/scs/site/prepaid-card_m22gqj.gif',
            title: 'Prepaid Card',
            description: 'Enjoy a Prepaid card tied to your account with personalized controls to ensure compliance of eligible trust disbursements.'
        }
    ] as const

    useScrollIntoView(link)

    return (
        <Box ref={link.componentRef} className="py-16 px-28 ltb_1300:px-12 tbmd:px-5 tbmd:py-8">
            <Typography className="mb-12 font-[Barlow] text-[40px] font-bold text-[#124B73] tbmd:text-center">Benefits of SCS Trust Services</Typography>
            <Box className="grid grid-cols-4 tbmd:block">
                {benefits.map((benefit) => (
                    <Box className="items-center py-6 px-8 tbmd:flex tbmd:flex-col tbmd:px-0" key={benefit.title}>
                        <Box className="flex h-[73px] w-[73px] items-center justify-center rounded-xl border-[2px] border-solid border-[#BBDEEB] bg-[#F8FAFC]">
                            <img width="65" height="65" src={benefit.imageSrc} alt={benefit.title} loading="lazy" decoding="async" />
                        </Box>
                        <Typography className="mt-6 mb-3 font-[Barlow] text-[15px] font-bold uppercase tracking-[1.95px] text-[#124B73]">
                            {benefit.title}
                        </Typography>
                        <Typography className="w-[217px] tbmd_1000:w-[100px] tbmd:w-full tbmd:text-center">{benefit.description}</Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default Benefits
